import { axiosPostCall } from '../api/axiosCall';
import { API_END_POINT, S3ImageFolder } from '../constant/constants';
import { AuthContext } from '../context/AuthProvider';
import { useContext } from 'react';

const uploadFile = async (file, folderName = S3ImageFolder.Product, token) => {
  try {
    // Create FormData for multipart/form-data
    const formData = new FormData();
    formData.append('image', file);

    const res = await axiosPostCall({
      apiEndPoint: `${API_END_POINT.UPLOAD_IMAGE}?FolderName=${folderName}`,
      header: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    if (res?.hideErrorFromUser) {
      return res.data; // Returns the S3 URL string
    } else {
      throw new Error(res?.error?.message || 'Failed to upload image');
    }
  } catch (error) {
    console.error('Error uploading image:', error);
    throw error;
  }
};

// Hook for using uploadFile with auth context
const useImageUpload = () => {
  const { token } = useContext(AuthContext);

  const uploadImage = async (file, folderName = S3ImageFolder.Product) => {
    if (!token) {
      throw new Error('Authentication token not available');
    }
    return uploadFile(file, folderName, token);
  };

  return { uploadImage };
};

export { uploadFile, useImageUpload, S3ImageFolder };
